import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { MensajeUsuario } from '../../../comun/entities/mensaje-usuario';
import { AuthGuardService } from '../../services/auth-guard.service';
import { AuthService } from '../../services/auth.service';
import { SesionService } from '../../services/session.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [AuthGuardService, MessageService],
})
export class LoginComponent implements OnInit, AfterViewInit {
  @Input() visible: boolean = true;

  subscription: Subscription;
  IsVisible: boolean = false;
  formLogin: FormGroup;
  typePassword = 'password';
  isPassword: boolean = true;
  version!: string;
  contadorFallas = 0;
  relojText!: string;
  msgs: Message[] = [];
  intentosMax = 5;
  visiblePinForm = false;
  flag: boolean = true;
  imagenUrl: string = '';
  esDemo: boolean = false;

  // ✨ NUEVO: Variable para tema navideño
  esTemporadaNavidad: boolean = false;

  googleLoginUrl: string;
  microsoftLoginUrl: string;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private sesionService: SesionService,
    private authService: AuthService,
    private messageService: MessageService,
    private authGuardService: AuthGuardService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
  ) {
    const appVersion = this.sesionService.getAppVersion();

    const clientId =
      '619817839324-56h6rsk5vqiqp7o6d10t1hg5i093nh18.apps.googleusercontent.com';
    const scope = 'openid email profile';
    const redirectUri = this.getRedirectUri();
    const googleState = this.generateRandomState();
    sessionStorage.setItem('oauth_state', googleState);
    document.cookie = `oauth_state=${googleState}; path=/; SameSite=Lax; Secure`;
    const googleStateWithVersion = `${googleState}|${appVersion}`;

    this.googleLoginUrl = `https://accounts.google.com/o/oauth2/v2/auth?scope=${encodeURIComponent(
      scope,
    )}&response_type=code&redirect_uri=${encodeURIComponent(
      redirectUri,
    )}&client_id=${clientId}&state=${encodeURIComponent(googleStateWithVersion)}&prompt=select_account`;

    const microsoftClientId = '4929bf29-5276-41fc-9596-f844419e904a';

    const microsoftScope = 'https://graph.microsoft.com/User.Read';
    const microsoftRedirectUri = this.getRedirectUri('microsoft');
    const microsoftState = this.generateRandomState();
    sessionStorage.setItem('oauth_state_microsoft', microsoftState);
    document.cookie = `oauth_state_microsoft=${microsoftState}; path=/; SameSite=Lax; Secure`;
    const microsoftStateWithVersion = `${microsoftState}|${appVersion}`;

    this.microsoftLoginUrl =
      `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?` +
      `client_id=${microsoftClientId}` +
      `&response_type=code` +
      `&redirect_uri=${encodeURIComponent(microsoftRedirectUri)}` +
      `&response_mode=query` +
      `&scope=${encodeURIComponent(microsoftScope)}` +
      `&state=${encodeURIComponent(microsoftStateWithVersion)}` +
      `&prompt=select_account`;
    this.subscription = this.authService
      .getLoginObservable()
      .subscribe((visible) => this.setVisible(visible));
    this.formLogin = fb.group({
      correo: [null, Validators.required],
      password: [null, Validators.required],
    });
  }
  esAmbienteDemo(url: string): boolean {
    return url.includes('demo.sigess.app');
  }

  // ✨ NUEVO: Método para verificar si es temporada navideña
  private verificarTemporadaNavidad(): boolean {
    const hoy = new Date();
    const mes = hoy.getMonth(); // 0 = enero, 11 = diciembre
    const dia = hoy.getDate();

    // 🎄 MODO PRUEBA: Activar del 20 de noviembre al 31 de diciembre
    // Para producción cambiar a: return mes === 11 && dia >= 1 && dia <= 31;
    return mes === 11 && dia >= 1 && dia <= 31;
  }

  mostrarDialogo: boolean = false;
  showDialog = false;
  showDialogUserActive = false;

  ngOnInit(): void {
    const state = this.generateRandomState();
    sessionStorage.setItem('oauth_state', state);
    sessionStorage.setItem('oauth_state_microsoft', state);

    const error = this.route.snapshot.queryParamMap.get('error');
    if (error === 'not-registered') this.showDialog = true;
    if (error === 'not-active') this.showDialogUserActive = true;

    if (error === 'access_denied') {
      this.messageService.add({
        severity: 'info',
        summary: 'Proceso Cancelado',
        detail: 'Se canceló el inicio de sesión externo.',
      });
      this.router.navigate(['/login'], { replaceUrl: true });
    }

    const currentUrl = window.location.href;
    this.esDemo = this.esAmbienteDemo(currentUrl);
    this.version = this.sesionService.getAppVersion();

    this.route.queryParams.subscribe((params) => {
      const token = params['token'];
      const refresh = params['refresh'];

      if (token) {
        this.flag = false;
        this.IsVisible = true;
        // Guardar tokens
        localStorage.setItem('token', token);
        if (refresh) localStorage.setItem('refresh', refresh);

        this.authService
          .loginConGoogleDesdeToken(token)
          .then((res: any) => {
            this.authService.onLoginDesdeGoogle(res);

            const fecha = res.usuario.fechaAceptaTerminos;
            const aceptaTerm = fecha != null && fecha > 0;

            if (aceptaTerm) {
              const url: string | null = localStorage.getItem('url');
              this.router.navigate([url ?? '/app/home']);
              localStorage.removeItem('url');
            } else {
              this.router.navigate(['/app/terminos']);
              this.authGuardService.Seturl('/app/home');
            }
          })
          .catch((err) => {
            this.IsVisible = false;
            this.flag = true;
            this.messageService.add({
              severity: 'error',
              summary: 'Error de Acceso',
              detail: 'No se pudo validar la sesión. Intente nuevamente.',
            });
            this.router.navigate(['/login']);
          });
      } else {
        if (
          this.sesionService.getEmpresa() != null &&
          this.sesionService.getUsuario() != null
        ) {
          this.router.navigate([this.authService.redirectUrl]);
          return;
        }
        let countDown = Number(localStorage.getItem('countDown'));
        if (countDown != null && countDown > 0) {
          this.contadorFallas = 5;
          this.iniciarContador(countDown);
        }
        this.flag = false;
        setTimeout(() => {
          if (this.formLogin) {
            this.correo = this.formLogin.value['correo'];
          }
          this.flag = true;
        }, 500);
      }
    });

    const control = this.formLogin.get('correo');
    control?.valueChanges.subscribe((value) => {
      if (value && value !== value.toLowerCase()) {
        control.setValue(value.toLowerCase(), { emitEvent: false });
      }
    });
  }

  closeDialog() {
    this.showDialog = false;
    this.showDialogUserActive = false;
  }
  private generateRandomState(): string {
    return Math.random().toString(36).substring(2) + Date.now().toString(36);
  }

  private getRedirectUri(provider: 'google' | 'microsoft' = 'google'): string {
    const protocol = window.location.protocol;
    const host = window.location.host;
    const basePath = '/sigess/api/authenticate/';
    const callback =
      provider === 'google' ? 'google/callback' : 'microsoft/callback';

    if (host.includes('localhost')) {
      return `http://localhost:8080${basePath}${callback}`;
    }

    return `${protocol}//${host}${basePath}${callback}`;
  }

  correo: string = '';

  ngAfterViewInit(): void {
    // tu lógica actual de advertencia
    if (localStorage.getItem('url')) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Advertencia',
        detail: 'Debe iniciar sesión para acceder a esta ruta.',
        life: 5000,
      });
    }

    // inicializar la nieve
    this.initSnow();
  }
  private initSnow(): void {
    const canvas = document.getElementById('snowCanvas') as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d')!;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const flakes: any[] = [];
    const numFlakes = 50;

    // Crear copos con traslación y rotación
    for (let i = 0; i < numFlakes; i++) {
      flakes.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: 5 + Math.random() * 10,
        dx: (Math.random() - 0.5) * 2, // traslación visible pero no excesiva
        dy: (Math.random() - 0.5) * 2,
        angle: Math.random() * Math.PI * 2, // ángulo inicial
        rotationSpeed: (Math.random() - 0.5) * 0.0001, // rotación muy lenta
        sides: Math.floor(6 + Math.random() * 3), // fija la forma (6–8 puntas)
      });
    }

    // Dibujar copo complejo con ramas
    const drawFlake = (flake: any) => {
      ctx.save();
      ctx.translate(flake.x, flake.y);
      ctx.rotate(flake.angle);
      ctx.strokeStyle = 'white';
      ctx.lineWidth = 1.5;

      const step = (Math.PI * 2) / flake.sides;
      const outerRadius = flake.r;

      ctx.beginPath();
      for (let i = 0; i <= flake.sides; i++) {
        const x = outerRadius * Math.cos(i * step);
        const y = outerRadius * Math.sin(i * step);
        ctx.lineTo(x, y);
      }
      ctx.closePath();
      ctx.stroke();

      // ramas en cada punta
      for (let i = 0; i < flake.sides; i++) {
        const x = outerRadius * Math.cos(i * step);
        const y = outerRadius * Math.sin(i * step);

        ctx.moveTo(x, y);
        ctx.lineTo(x * 1.3, y * 1.3);

        const branchAngle = step / 4;
        const bx1 = outerRadius * 1.2 * Math.cos(i * step + branchAngle);
        const by1 = outerRadius * 1.2 * Math.sin(i * step + branchAngle);
        ctx.moveTo(x, y);
        ctx.lineTo(bx1, by1);

        const bx2 = outerRadius * 1.2 * Math.cos(i * step - branchAngle);
        const by2 = outerRadius * 1.2 * Math.sin(i * step - branchAngle);
        ctx.moveTo(x, y);
        ctx.lineTo(bx2, by2);
      }
      ctx.stroke();

      ctx.restore();
    };

    // Animación con traslación y rotación lentas
    const update = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      flakes.forEach((flake) => {
        // traslación lenta
        flake.x += flake.dx * 0.2;
        flake.y += flake.dy * 0.2;

        // rebote en bordes
        if (flake.x < 0 || flake.x > canvas.width) flake.dx *= -1;
        if (flake.y < 0 || flake.y > canvas.height) flake.dy *= -1;

        // rotación muy lenta
        flake.angle += flake.rotationSpeed;

        drawFlake(flake);
      });

      requestAnimationFrame(update);
    };

    update();
  }

  tooglePsw() {
    this.isPassword = !this.isPassword;
    if (this.isPassword) {
      this.typePassword = 'password';
    } else {
      this.typePassword = 'text';
    }
  }

  async validate(value: any) {
    if (
      value.correo &&
      (value.correo.toLowerCase().endsWith('@coronas.com.co') ||
        value.correo.toLowerCase().endsWith('@algoincesastd.com'))
    ) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Ingreso Restringido',
        detail:
          'Autenticación delegada a SSO para este dominio. Continúe con Microsoft.',
        life: 6000,
      });
      this.IsVisible = false;
      return;
    }
    let res: any;
    try {
      await this.authService
        .checkisLoginExist(value.correo, value.password)
        .then((result) => {
          res = result;
        })
        .catch((err) => {
          // console.log('err: '+ JSON.stringify(err));
          if (err.status === 400) {
            res = { exit: 'false' };
          } else {
            res = err;
            res = {
              ...res,
              exit: '',
            };
          }
        });
      if (res!.exit == 'true') {
        this.confirmationService.confirm({
          message: 'Se perderan los cambios no guardados de sus otras sesiones',
          header: 'Atención',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.login(value);
          },
        });
      } else {
        this.login(value);
      }
    } catch (error: any) {
      if (error.status === 400) res = { exit: 'false' };
      location.reload();
    }
  }

  async login(value: any) {
    this.IsVisible = true;
    try {
      await this.authService
        .login(value.correo, value.password, value.recordar, value.pin)
        .then((res) => {
          let aceptaTerm =
            this.authService.sesionService.getUsuario()!.fechaAceptaTerminos !=
            null;
          if (aceptaTerm) {
            this.authService.onLogin(res);
            let url: string | null = localStorage.getItem('url');
            this.router.navigate([url ?? 'app/home']);
            localStorage.removeItem('url');
            // this.IsVisible = false;
          } else {
            let url = this.authGuardService.Geturl();
            this.router.navigate([aceptaTerm ? url : '/app/terminos']);
            this.authGuardService.Seturl('/app/home');
          }
        });
    } catch (err: any) {
      this.IsVisible = false;
      this.msgs = [];
      if (err['name'] != null && err['name'] == 'TimeoutError') {
        this.messageService.add({
          severity: 'warn',
          summary: 'CONEXIÓN DEFICIENTE',
          detail:
            'La conexión está tardando mucho tiempo en responder, la solicitud ha sido cancelada. Por favor intente mas tarde.',
        });
        return;
      }
      let msg: MensajeUsuario = err.error;
      switch (err.status) {
        case 403:
          this.messageService.add({
            severity: 'error',
            summary: 'CREDENCIALES INCORRECTAS',
            detail: 'El usuario o contraseña especificada no son correctas',
          });
          break;
        case 401:
          if (msg.codigo == 2_007) {
            this.visiblePinForm = true;
          }
          if (msg.codigo == 2_009) {
            this.contadorFallas = this.intentosMax;
          }
          this.messageService.add({
            severity: msg.tipoMensaje,
            summary: msg.mensaje,
            detail: msg.detalle,
          });
          break;
        case 400:
          this.messageService.add({
            severity: msg.tipoMensaje,
            summary: msg.mensaje,
            detail: msg.detalle,
          });
          break;
        default:
          this.messageService.add({
            severity: 'error',
            summary: 'ERROR',
            detail: 'Se ha generado un error no esperado',
          });
          break;
      }
      this.contadorFallas += 1;
      if (this.contadorFallas >= this.intentosMax) {
        this.iniciarContador(new Date().getTime() + 2 * 60 * 1000);
      }
    }
  }

  iniciarContador(countDown: number) {
    localStorage.setItem('countDown', '' + countDown);
    let interval = window.setInterval(() => {
      let now = new Date().getTime();
      let distance = countDown - now;
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
      this.relojText = minutes + 'm ' + seconds + 's ';
      if (distance < 0) {
        clearInterval(interval);
        this.contadorFallas = 0;
        localStorage.removeItem('countDown');
      }
    }, 1000);
  }

  setVisible(visible: boolean) {
    this.messageService.add({
      severity: 'warn',
      summary: 'pro',
      detail: 'Se cerro su sesion inicie de nuevo por favor',
    });
    this.visible = visible;
  }
}
